import React from 'react';
import { Card } from 'react-bootstrap'
import '../styles/LargeButton/LargeButton.scss'

function Large_Button({ children, className, onClick, src, alt }){

    return(
        <Card className={`button compare-button ${src ? 'large-button' : 'small-button'}`}>
            <Card.Body className={`${className} text-center  text-uppercase`} onClick={onClick}>
                {src &&<div className={'image-content'}>
                    <img height={70} width={70} src={src} alt={alt}/>
                </div>}
                {children}
            </Card.Body>
        </Card>
    )
}

export default Large_Button;